import { call, put, select } from 'typed-redux-saga'
import { AnyAction } from 'redux'

import services from '@services'
import {
  ConsultaMargemResultPayload,
  MarginAcceptApiErrorCodes,
  MarginAcceptApiErrorResponse,
  MarginApiResponse,
} from '@store/refinanciamento/marginAcceptResult/types'
import { showError } from '@store/ui/error/actions'
import { setLastServiceResponse } from '@store/session/actions'
import { ApplicationState } from '@store/types'
import { StepRefin } from '@utils/enums'
import { TResponseType } from '@services/base'
import { ServiceResponseError } from '@exceptions'

import { marginResultRequest, marginResultSuccess, marginResultError } from '../actions'

const extractApiErrorCode = (error: unknown): string | undefined => {
  const errorData = (error as ServiceResponseError | undefined)?.data as
    | MarginAcceptApiErrorResponse
    | undefined

  return errorData?.errors?.find((item) => Boolean(item?.message))?.message
}

export default function* postMarginResultSaga(action: AnyAction) {
  const payload = action.payload as ConsultaMargemResultPayload
  try {
    const { accessToken } = yield* select((state: ApplicationState) => state.session)

    const resultResponse: TResponseType<MarginApiResponse> = yield* call(
      services.postContractMarginResultService,
      {
        accessToken,
        convenioName: payload.convenioName,
      },
    )

    yield* put(
      setLastServiceResponse({
        code: resultResponse.data?.code || 'OK',
        serviceName: 'postContractMarginResultService',
      }),
    )
    yield* put(marginResultSuccess())
    yield* call(payload.callback, resultResponse.data.code)
  } catch (error) {
    yield* put(marginResultError())

    const errorCode = extractApiErrorCode(error)

    yield* put(
      setLastServiceResponse({
        code: errorCode ?? 'ERROR',
        serviceName: 'postContractMarginResultService',
      }),
    )

    if (errorCode === MarginAcceptApiErrorCodes.PROCESSAMENTO_VIRADA_COMPETENCIA) {
      yield* call(payload.callback, errorCode)
      return
    }

    yield* put(
      showError({
        title: 'Erro',
        message: 'Ocorreu um erro ao consultar a margem',
        actionTitle: 'Tentar Novamente',
        code: StepRefin.ERRO_CONSULTA_MARGEM,
        actionCallback: () => marginResultRequest(payload),
        block: true,
      }),
    )
  }
}
